import { Table } from "antd";
import React, { FC, useMemo, useState } from "react";
import { ApplicantsColumns, IApplicant } from "../helper";

interface Props {
  applicants: Array<IApplicant>;
  projectId?: string;
  refetch: () => void;
  onStatusChange: (id: string, status: string) => void;
  openProfileDrawer: (applicant: IApplicant) => void;
  openRemarks: (jobApplicationId: string) => void;
  openFeedback: (id: string, feedback: string) => void;
  setViewOfferModal: React.Dispatch<React.SetStateAction<{ visible: boolean; record?: IApplicant }>>;
  unreadCounts?: { [id: string]: number };
  handleApprove?: (applicationId: string) => void;
  handleReject?: (applicationId: string) => void;
}

export const ApplicantsList: FC<Props> = ({ applicants, refetch, onStatusChange, openProfileDrawer, openRemarks, openFeedback, setViewOfferModal, unreadCounts, handleApprove, handleReject }) => {
  const dataSource = useMemo(
    () => applicants.map((e) => ({ ...e, key: e._id })),
    [applicants]
  );

  return (
    <Table
      dataSource={dataSource}
      columns={ApplicantsColumns(
        refetch,
        onStatusChange,
        openProfileDrawer,
        openRemarks,
        openFeedback,
        setViewOfferModal,
        unreadCounts,
        handleApprove,
        handleReject,
      )}
    />
  );
};

export default ApplicantsList;
